module.exports = __webpack_public_path__ + "static/media/hero_mobile.bcb82b9f.webp";